export const PLAYOFF_EMPTY_STAGES = [
  {
    id: 18,
    stage: '1/8 финала',
    matches: [
      {
        id: '4001652',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4000964',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4001653',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4001650',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4001655',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4001654',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4001651',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4000968',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      }
    ]
  },
  {
    id: 14,
    stage: '1/4 финала',
    matches: [
      {
        id: '4002999',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4003294',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4003583',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4002886',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      }
    ]
  },
  {
    id: 12,
    stage: 'Полуфинал',
    matches: [
      {
        id: '4005016',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      },
      {
        id: '4005429',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      }
    ]
  },
  {
    id: 1,
    stage: 'Финал',
    matches: [
      {
        id: '4006729',
        date: '2022-12-03T16:00:00.000Z',
        localTeam: {
          id: 6737,
          name: '-',
          score: 0
        },
        visitorTeam: {
          id: 14227,
          name: '-',
          score: 0
        }
      }
    ]
  }
];
